import PageShell from "@/components/PageShell";
import Faq from "@/components/Faq";

export default function FaqPage({ onLead }) {
  return (
    <PageShell backdrop="/homes/scale-750.webp" title="Mortgage FAQ — My First Home Mortgage Ltd">
      <Faq onLead={onLead} />
    </PageShell>
  );
}
